/**
 * My Rewards Block - Frontend AJAX Pagination
 */

document.addEventListener('DOMContentLoaded', function() {
	const rewardsBlocks = document.querySelectorAll('.wp-block-xtra-my-rewards');
	
	rewardsBlocks.forEach(block => {
		const contentWrapper = block.querySelector('.xtra-my-rewards-content');
		if (!contentWrapper) return;
		
		// Get block data
		const itemsPerPage = parseInt(block.dataset.itemsPerPage) || 10;
		let currentPage = parseInt(block.dataset.currentPage) || 1;
		const totalPages = parseInt(block.dataset.totalPages) || 1;
		
		// Add event listeners to pagination links
		block.addEventListener('click', async (e) => {
			const target = e.target.closest('.xtra-pagination-prev, .xtra-pagination-next, .xtra-pagination-number');
			if (!target) return;
			
			e.preventDefault();
			
			const newPage = parseInt(target.dataset.page);
			if (newPage === currentPage) return;
			
			// Add loading state
			contentWrapper.style.opacity = '0.5';
			contentWrapper.style.pointerEvents = 'none';
			
			try {
				// Fetch new data
				const response = await fetch(`${window.XXRest?.root || '/wp-json/'}xtraxtra-blocks/v1/my-rewards?page=${newPage}&per_page=${itemsPerPage}`, {
					method: 'GET',
					headers: {
						'X-WP-Nonce': window.XXRest?.nonce || '',
					},
				});
				
				if (!response.ok) {
					throw new Error('Failed to load rewards');
				}
				
				const text = await response.text();
				let data;
				try {
					data = JSON.parse(text);
				} catch (e) {
					console.error('Response was not JSON:', text);
					throw new Error('Invalid response format');
				}
				
				// Build new HTML
				let html = '<table class="xxa-myrewards wp-block-table">';
				html += '<thead><tr><th>Reward</th><th>Date</th><th>Status</th></tr></thead><tbody>';
				
				data.items.forEach(item => {
					const statusClass = `xxa-status xxa-status--${item.status}`;
					html += '<tr>';
					html += `<td class="xxa-reward-name">${escapeHtml(item.reward_name)}</td>`;
					html += `<td class="xxa-date">${item.date}</td>`;
					html += `<td class="${statusClass}">${item.status}</td>`;
					html += '</tr>';
				});
				
				html += '</tbody></table>';
				
				// Build pagination
				if (data.pages > 1) {
					html += '<div class="xtra-my-rewards-pagination">';
					
					// Previous button
					if (data.current_page > 1) {
						html += `<a href="#" class="xtra-pagination-prev" data-page="${data.current_page - 1}">&larr; Previous</a>`;
					}
					
					// Page numbers
					html += '<span class="xtra-pagination-numbers">';
					for (let i = 1; i <= data.pages; i++) {
						if (i === data.current_page) {
							html += `<span class="xtra-pagination-current">${i}</span>`;
						} else {
							html += `<a href="#" class="xtra-pagination-number" data-page="${i}">${i}</a>`;
						}
					}
					html += '</span>';
					
					// Next button
					if (data.current_page < data.pages) {
						html += `<a href="#" class="xtra-pagination-next" data-page="${data.current_page + 1}">Next &rarr;</a>`;
					}
					
					html += '</div>';
				}
				
				// Update content
				contentWrapper.innerHTML = html;
				currentPage = data.current_page;
				
				// Update URL without reload
				const url = new URL(window.location);
				url.searchParams.set('rewards_page', currentPage);
				window.history.pushState({}, '', url);
				
				// Scroll to top of block
				block.scrollIntoView({ behavior: 'smooth', block: 'start' });
				
			} catch (error) {
				console.error('Error loading rewards:', error);
				// Optionally show error message
			} finally {
				// Remove loading state
				contentWrapper.style.opacity = '';
				contentWrapper.style.pointerEvents = '';
			}
		});
	});
});

// Helper function to escape HTML
function escapeHtml(text) {
	const div = document.createElement('div');
	div.textContent = text;
	return div.innerHTML;
}